export const BookingPaymentMethodId = {
  Cash: 1, // 現金
  CCTOP: 21, // TOP
  CCDC: 22, // DC
  CCUC: 23, // UC
  CCMaster: 24, // MASTER
  CCVisa: 25, // VISA
  CCJCB: 26, // JCB
  CCUnionPay: 27, // 銀聯
  VoucherStore: 41, // ストア 商品券
  VoucherDepart: 42, // 百貨店 商品券
  VoucherRecreation: 43, // ホテルズ ギフトカード it used to be -> レク券 商品券
  VoucherCampaignDiscount: 44, // キャンペーン割引券 added in TO2020-658
  TokyuPoint: 61, // TOKYUポイント
  TVP: 62, // TVP
  OnAccount: 81, // 売掛
  OTAPayment: 82, // OTA精算
  OTAPointJalan: 83, // OTAポイント（じゃらん）
  OTAPointIkkyu: 84, // OTAポイント（一休）
  OTAPointRakuten: 85, // OTAポイント（楽天トラベル）
  OTAPointRurubu: 86, // OTAポイント（るるぶトラベル）
  OTAPointOther: 87, // OTAポイント（その他）
  RegisteredCC: 101 // 登録カード
}

// Display labels for a charge subject's settlement method on the booking summary
export const BookingPaymentMethodLabel = {
  Settled: '精算済み',
  RegisteredCC: '登録カード',
  Onsite: '現地精算'
}
